<template>
  <template v-if="Object.prototype.hasOwnProperty.call(node, 'text')">{{ node.text }}</template>
  <component v-else :is="node.tag" v-bind="node.attrs">
    <MarketingContentNode
      v-for="(child, index) in node.children"
      :key="index"
      :node="child"
    />
  </component>
</template>

<script>
export default {
  name: 'MarketingContentNode',
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
};
</script>
